module.exports = __webpack_public_path__ + "static/media/go-big-go-home-banner-mobile.142a6357.webp";